import { americanDateParser } from 'utils/parsers/date'

type Props = {
  dateFilterType?: string
  startDate?: string
  finalDate?: string
  startHour?: string
  finalHour?: string
}

export function formatDateHourForAPI({ dateFilterType, startDate, finalDate, startHour, finalHour }: Props) {
  if (!startDate) return { startDate: '', finalDate: '' }

  const americanFormatStartDate = americanDateParser(startDate)
  const americanFormatFinalDate = finalDate ? americanDateParser(finalDate) : americanDateParser(startDate)

  const completeStartHour = startHour ? `${startHour}:00` : '00:00'
  const completeFinalHour = finalHour ? `${finalHour}:59` : '23:59'

  const offset = new Date().getTimezoneOffset()
  const formatted = offset / 60
  const signal = formatted > 0 ? '-' : '+'
  const hour = formatted <= 9 ? `0${formatted}` : formatted

  if (dateFilterType === 'Data posterior a') {
    return {
      startDate: `${americanFormatStartDate}T${completeStartHour}.000${signal}${hour}:00`,
      finalDate: `3000-01-31T${completeFinalHour}.000${signal}${hour}:00`,
    }
  } else if (dateFilterType === 'Data anterior a') {
    return {
      startDate: `1500-01-31T${completeStartHour}.000${signal}${hour}:00`,
      finalDate: `${americanFormatFinalDate}T${completeFinalHour}.000${signal}${hour}:00`,
    }
  } else if (dateFilterType === 'Data exata: ') {
    return {
      startDate: `${americanFormatStartDate}T00:00:00.000${signal}${hour}:00`,
      finalDate: `${americanFormatStartDate}T23:59:00.000${signal}${hour}:00`,
    }
  } else {
    return {
      startDate: `${americanFormatStartDate}T${completeStartHour}.000${signal}${hour}:00`,
      finalDate: `${americanFormatFinalDate}T${completeFinalHour}.000${signal}${hour}:00`,
    }
  }
}
